module.exports = "query GetAwards {\n  awards {\n    ...AwardFragment\n  }\n}\n"